import MyAccountPage from './MyAccountPage';

export default MyAccountPage;
